const menu = {
    single_sign_on: 'Authentification unique',
    profile: 'Profile',
    language: 'Langue',
    appearance: {
        label: 'Apparence',
        light: 'Mode clair',
        dark: 'Mode sombre',
        system: 'Synchronisation avec le système',
    },
    sign_out: 'Sign Out',
};
export default Object.freeze(menu);
